import script from "./SettingsOrgReferenceToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsOrgReferenceToolbar.vue?vue&type=script&setup=true&lang=js"

import "./SettingsOrgReferenceToolbar.vue?vue&type=style&index=0&id=22bf7d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22bf7d8c"]])

export default __exports__